/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
* Renders a PickLinkField in a table. One field instance serves every row, so everything shown
* here is derived from focusItem - never from the field's own displayText, which belongs to the
* form. Choosing and clearing are form actions, so no icons are offered here.
*/
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AbstractObject } from '@src/app/model/abstract-object';
import { PickLinkField } from '@src/app/shared/field/PickLinkField';

@Component({
    selector: 'app-pick-link-table-cell',
    imports: [RouterModule],
    templateUrl: './pick-link-table-cell.component.html',
    styleUrl: './pick-link-table-cell.component.scss'
})
export class PickLinkTableCellComponent {
    @Input({ required: true }) field: PickLinkField;
    @Input({ required: true }) focusItem: AbstractObject;
}
